'use strict';

var hoverintent = require('hoverintent');
var Constants = require('../../constants/constants');
var Overlay = require('../../overlay/overlay');

var Visibility = function(config) {

  var self = this;
  var $item = $(config.item);
  var $link = $(config.link);
  var $megamenuItem = $(config.megamenuItem);
  var megamenuItemGrid = config.megamenuItemGrid;
  var megamenuItemGridClassname = megamenuItemGrid.replace(/\./g, '');
  var $mainHeader = $(config.mainHeader);
  var $html = $('html');
  var $document = $(document);

  self.parseItems = function() {
    $item.each(function() {
      var $this = $(this);
      var _$link = $this.find($link);

      if ($this[0].hasAttribute('id')) {

        var slug = $this.attr('id').match(/\d+/)[0]; // Get digits from wp generated id: #menu-item-40

        self.parseMegamenuItems(_$link, slug);
      }
    });
  }

  self.parseMegamenuItems = function(_$link, slug) {
    $megamenuItem.each(function() {
      var $this = $(this);
      var _slug = $this.attr('data-menu-item-slug');

      if (_slug === slug) {
        self.wrapMegamenuContent(_$link, $this)
      }
    });
  }

  self.wrapMegamenuContent = function(_$link, _$megamenuItem) {

    var _$inner = _$megamenuItem.find(megamenuItemGrid);

    if (_$inner.length === 0) {
      _$megamenuItem.wrapInner('<div class="' + megamenuItemGridClassname + '"></div>');
      _$inner = _$megamenuItem.find(megamenuItemGrid);
    }

    self.disableClickEvents(_$link);
    self.hoverHandler(_$link, _$megamenuItem, _$inner);
    self.focusHandler(_$link, _$megamenuItem, _$inner);
  }

  self.hoverHandler = function(_$link, _$megamenuItem, _$inner) {

    var myLink = _$link[0];
    var mq = new Constants().MEDIA_QUERIES.MEDIUM;
    var mql = window.matchMedia(mq);

    var hoverEvents = hoverintent(myLink, function(e) {
      self.subnavVisibility(_$link, _$megamenuItem, _$inner);
    }, function(){}).options({interval: 100});

    // Remove hoverintent listeners
    var mediaQueryHandler = function(mql) {

      if (! mql.matches) {
        hoverEvents.remove();
      }
    };

    mql.addListener(mediaQueryHandler);
    mediaQueryHandler(mql);
  }

  self.focusHandler = function(_$link, _$megamenu, _$inner) {

    _$link.on('focus.megamenu', function() {
      self.subnavVisibility(_$link, _$megamenu, _$inner);
    });
  }

  self.disableClickEvents = function(_$link) {
    _$link.on('click.megamenu', function(e) {
      e.preventDefault();
    });
  }

  self.subnavVisibility = function(_$link, _$megamenuItem, _$inner) {

    var showMySubnav = function() {
      self.showSubnav(_$megamenuItem, _$inner);
    };

    if ($megamenuItem.hasClass('is-visible')) {
      self.hideCurrentSubnavs(_$megamenuItem, showMySubnav);
    } else {
      showMySubnav();
    }

    $link.removeClass('is-active');
    _$link.addClass('is-active');
  }

  self.hideCurrentSubnavs = function($currentSubnav, cb, lastTime, keepOverlay) {

    var lastTime = lastTime || false;
    var keepOverlay = keepOverlay || false;

    if ($megamenuItem.not($currentSubnav).hasClass('is-visible')) {

      $megamenuItem.not($currentSubnav).each(function() {
        var $this = $(this);

        if ($this.hasClass('is-visible')) {
          var _$innr = $this.find(config.megamenuItemGrid);
          self.hideSubnav($this, _$innr, lastTime, cb, keepOverlay);
        }
      });
    }
  }

  self.mouseOutOuter = function() {

    var mq = new Constants().MEDIA_QUERIES.MEDIUM;
    var mql = window.matchMedia(mq);

    var hoverEvents = hoverintent($mainHeader[0], function(e) {}, function(){
      self.hideCurrentSubnavs(null, null, true);
      $link.removeClass('is-active');
    });

    // Remove hoverintent listeners
    var mediaQueryHandler = function(mql) {

      if (! mql.matches) {
        hoverEvents.remove();
      }
    };

    mql.addListener(mediaQueryHandler);
    mediaQueryHandler(mql);
  }

  self.focusOutOuter = function() {

    var $lastLink = $mainHeader.find('a').last();

    $lastLink.blur(function() {
      self.hideCurrentSubnavs(null, null, true);
    });
  }

  self.showSubnav = function(_$megamenuItem, _$inner) {

    if (! $megamenuItem.hasClass('velocity-animating') && ! _$megamenuItem.hasClass('is-visible')) {

      self.linkPointerEvents.disable();
      $html.addClass('megamenu-is-open');
      new Overlay().showOverlay();
      _$megamenuItem
        .addClass('is-visible')
        .css('z-index', '2')
        .velocity(
          'slideDown',{
            duration: 200,
            complete: function() {

            }
          });
      _$inner
        .velocity({
          opacity: 1
        },{
          duration: 160,
          delay: 150,
          complete: function() {
            self.linkPointerEvents.enable();
          }
        });
    }
  }

  self.hideSubnav = function(_$megamenuItem, _$inner, lastTime, cb, keepOverlay) {

    var delay = 0;

    if (typeof cb === 'function') {
      delay = 300;
    }

    self.linkPointerEvents.disable();
    $html.removeClass('megamenu-is-open');

    _$megamenuItem
      .removeClass('is-visible')
      .css('z-index', '1');

    if (lastTime && !$html.hasClass('search-modal-is-open') && !keepOverlay) {
      new Overlay().hideOverlay();
    }

    _$inner
      .velocity({
        opacity: 0
      },{
        duration: 160,
        complete: function() {

          if (typeof cb === 'function') {
            cb();
          }
        }
      });
    _$megamenuItem
      .velocity(
        'slideUp',{
          duration: 230,
          delay: delay,
          complete: function() {
            self.linkPointerEvents.enable();
          }
        });
  }

  self.documentClickHandler = function() {
    $document.on('click.megamenuVisibility', function(e) {
      if (!$(e.target).closest($mainHeader).length) {
        if ($megamenuItem.hasClass('is-visible') && !$megamenuItem.hasClass('velocity-animating')) {
          self.hideCurrentSubnavs(null, null, true);
          $link.removeClass('is-active');
        }
      }
    });
  }

  self.linkPointerEvents = {
    disable: function() {
      $link.addClass('no-pointer-events');
    },
    enable: function() {
      $link.removeClass('no-pointer-events');
    }
  }

  self.destroy = function() {

    var $lastLink = $mainHeader.find('a').last();

    $link
      .off('focus.megamenu click.megamenu')
      .removeClass('is-active');
    $megamenuItem
      .removeClass('is-visible')
      .removeAttr('style');
    $(megamenuItemGrid)
      .velocity('stop')
      .removeAttr('style');
    $lastLink.off('blur');
    new Overlay().hideOverlay();
  }

  self.init = function() {
    self.parseItems();
    self.mouseOutOuter();
    self.focusOutOuter();
    self.documentClickHandler();
  }
};

module.exports = Visibility;
